import { QuestionCircleOutlined, BellOutlined } from "@ant-design/icons";
import { Badge, Button, Col, Row } from "antd";
import { useState } from "react";
import "./menu-buttons.css";
import { useNavigate } from "react-router-dom";

export const MenuButtons = () => {
  const [notifications, setNotifications] = useState(true);

  const navigate = useNavigate();

  return (
    <Row>
      <Col>
        <Button
          className="middle-menu-options"
          size="middle"
          shape="circle"
          icon={<QuestionCircleOutlined />}
          ghost={true}
          onClick={() => (navigate("download"))}
        />
      </Col>
      {/* <Col>
        <Badge
          dot={notifications}
          color="orange"
          offset={[-15, 10]}
          size="small"
        >
          <Button
            className="middle-menu-options"
            size="middle"
            shape="circle"
            icon={<BellOutlined />}
            ghost={true}
            onClick={DismissNotifications}
          />
        </Badge>
      </Col> */}
    </Row>
  );
};
